<template>
    <v-container>
    <div>
        <v-flex>
            <v-row>
                <h1 class="page-title">Restaurants</h1>
                <v-spacer class="line"></v-spacer>
                <hr>
                <new-restaurant-modal></new-restaurant-modal>
            </v-row>
        </v-flex>

        <v-row dense>
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete
        v-model="filter_area"
        :items="areas"
        item-text="name"
        item-value="id"
        label="All Areas"
        solo
        clearable
        hide-details
        @change="onAreaChange"
    >
        <template slot="selection" slot-scope="data">
            <div>
                <div v-html="data.item.name" />
            </div>
        </template>
    </v-autocomplete>
          </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                    v-model="filter_status"
                    :items="restaurant_status_list"
                    item-text="name"
                    item-value="id"
                    label="All statuses"
                    solo
                    clearable
                    hide-details
                    v-on:change="onStatusfilter"
                >
                    <template
                        slot="selection"
                        slot-scope="data"
                    >
                        <div>
                            <div v-html="data.item.name" />
                        </div>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                    v-model="restaurateurFilter"
                    :items="restaurateurs"
                    label="Search Restaurateur"
                    item-text="email"
                    item-value="id"
                    solo
                    clearable
                    hide-details
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-text-field
                    solo
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    v-model="filter_search"
                    label="Search Restaurant"
                    clearable
                ></v-text-field>
            </v-col>
          
        </v-row>

        <span v-if="restaurantsSearchedPaged.length === 0">No restaurants found</span>
        <div class="restaurants-table"  v-if="restaurantsSearchedPaged.length !== 0">
            <v-simple-table>
            <thead>
            <tr>
                <th class="text-left">Restaurant Name</th>
                <th class="text-left">Location Address</th>
		<th class="text-left">Email</th>
                <th class="text-left">Area</th>
                <th class="text-right">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="restaurant of restaurantsSearchedPaged" :key="restaurant.id">
                <td>{{ restaurant.name }}</td>
                <td class="pl-0 pr-0"><restaurant-address-modal :thisRestaurantId="restaurant.id"></restaurant-address-modal></td>
                <td>{{ restaurant.restaurateur.email}}</td>
		<td>{{ getAreaName(restaurant.area_id) }}</td>
                <td>
                    <v-btn-toggle class="float-right edit-button-group">
                        <edit-restaurant-modal :thisRestaurantData="restaurant" @updated="restaurantEdited"></edit-restaurant-modal>
                        <template>
                        <div class="text-center">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                            tile
                                            small
                                            class="primary dropdown-menu-activator"
                                            depressed
                                            v-on="on"
                                    ><v-icon>mdi-menu-down</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item>
                                    <v-list-item-title v-if="restaurant.status == RESTAURANT_STATUS_ACTIVE" class="pointer"
                                                       @click="inactiveItem(RESTAURANT_STATUS_INACTIVE, restaurant.id)">Mark as Inactive</v-list-item-title>
                                    <v-list-item-title v-else class="pointer"
                                                       @click="inactiveItem(RESTAURANT_STATUS_ACTIVE, restaurant.id)">Mark as Active</v-list-item-title>
                                  </v-list-item>
                                    <v-list-item @click="deleteRestaurant(restaurant)">
                                        <v-list-item-title>Delete</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                            @click="goToSchedule(restaurant.id)"
                                            :restaurantId="restaurant.id"
                                    >
                                        <v-list-item-title>Schedule</v-list-item-title>
                                    </v-list-item>

                                    <drivers-list-modal :restaurantId="restaurant.id"></drivers-list-modal>

                                    <new-post-modal :restaurantId="restaurant.id"></new-post-modal>
                                    <v-list-item :href="config.freeagent_base_url + 'contacts/' + restaurant.freeagent_id"target="_blank"style="text-decoration: none; color: inherit;">
                                    <v-list-item-title>View Contact</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="resetInvoicePin(restaurant.restaurateur_id)"><v-list-item-title class="red--text">Reset Invoice PIN</v-list-item-title></v-list-item>

                                </v-list>
                            </v-menu>
                        </div>
                        </template>
                    </v-btn-toggle>
                </td>
            </tr>
            </tbody>
            </v-simple-table>
            <v-row>
                <v-col cols="12" sm="2" md="2">
                    <v-flex class="d-flex flex-row">
                        <div style="min-width:75px" class="pt-2">
                            Per page:
                        </div>
                        <v-select
                            :items="per_page_list"
                            label="Solo field"
                            solo
                            dense
                            v-model="per_page"
                            v-on:change="onCangePerPage"
                            hide-details=""
                        ></v-select>
                    </v-flex>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                <v-pagination
                    :value="page"
                    :length="total_pages"
                    :total-visible="10"
                    @input="onChangePage"
                ></v-pagination>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    {{((page - 1) * per_page) + 1}}&nbsp;-&nbsp;{{ ((page * per_page) < restaurantsSearched.length) ? (page * per_page) : restaurantsSearched.length }}&nbsp;of&nbsp;{{restaurantsSearched.length}}
                </v-col>
            </v-row>
        </div>
    </div>
</v-container>

</template>

<script>
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'
    import config from '@/configs/config';

    const RESTAURANT_STATUS_ACTIVE = 10;
    const RESTAURANT_STATUS_INACTIVE = 20;

    export default {
        name: "Restaurants",
        data: () => ({
            localLoading: false,
            config,
            // components: [],
            filter_search: void 0,
            restaurateurFilter: void 0,
            RESTAURANT_STATUS_ACTIVE: RESTAURANT_STATUS_ACTIVE,
            RESTAURANT_STATUS_INACTIVE: RESTAURANT_STATUS_INACTIVE,
            filter_status: RESTAURANT_STATUS_ACTIVE, // default active only
            filter_search: '',
            filter_area: null,
            page: 1,
            per_page: 15,
            per_page_list: [10, 15, 50, 100, 1000],
            restaurant_status_list: [
              // { id: 0, type: 'root', name: 'Show all'},
              { id: RESTAURANT_STATUS_ACTIVE, type: 'root', name: 'Show only active' },
              { id: RESTAURANT_STATUS_INACTIVE, type: 'root', name: 'Show only inactive' },
            ],
        }),
        created() {
            Promise.all([
                this.$store.dispatch('fetchAreas'),
                this.$store.dispatch('fetchRestaurateurs'),
                this.$store.dispatch('fetchDrivers'),
                this.$store.dispatch('fetchOptions'), // map_center
            ]).then(() => {
                this.$store.dispatch('fetchRestaurants');
            })
        },
        computed: {
            ...mapGetters([
                'areas',
                'restaurants',
                'drivers',
                'restaurateurs',
            ]),
            restaurantsSearched() {
                let result = this.restaurants;

                if (this.filter_search) {
                    result = _.filter(result, p => p.name.toLowerCase().indexOf(this.filter_search) !== -1);
                }
                if (this.filter_area) {
    result = result.filter((restaurant) => restaurant.area_id == this.filter_area);
}

                if (this.restaurateurFilter) {
                    result = _.filter(result, p => p.restaurateur && p.restaurateur_id == this.restaurateurFilter);
                }
                // filter data full progress
                switch (this.filter_status) {
                    case RESTAURANT_STATUS_ACTIVE:
                        result = _.filter(result, p => p.status == this.filter_status);
                        break;
                    case RESTAURANT_STATUS_INACTIVE:
                        result = _.filter(result, p => p.status == this.filter_status);
                        if(result.length===0) {
                            let status =this.filter_status;
                            this.$store.dispatch('fetchRestaurants', status);
                        }
                        break;
                }
                return result;
            },
            restaurantsSearchedPaged() {
                let start = this.per_page * (this.page - 1);
                let end = start + this.per_page;
                return this.restaurantsSearched.slice(start, end);
            },
            total_pages() {
                return Math.ceil(this.restaurantsSearched.length / this.per_page);
            },
        },
        methods: {
            onAreaChange() {
        console.log("Selected Area ID:", this.filter_area);
        this.filterRestaurants();
    },
            deleteRestaurant(restaurant) {
                if (!confirm('Remove restaurant ' + restaurant.name + '?')) {
                    return; // exit
                }

                this.localLoading = true
                this.$store.dispatch('deleteRestaurant', restaurant)
                    .then(() => {
                    })
                    .catch(error => {
                        if(error && error.response && error.response.data && error.response.data.id) {
                            alert(error.response.data.id[0]);
                        }
                    }).finally(() => {
                        this.localLoading = false;
                    });
            },
            inactiveItem(status, restaurant_id) {
              this.localLoading = true
              this.$store.dispatch('setRestaurantStatus', {status, restaurant_id}).then(() => {
              }).finally(() => {
                this.localLoading = false;
              });
            },
            onChangePage(page) {
                this.page = page;
            },
            goToSchedule(restaurant_id) {
                localStorage.setItem('redirrected_from_restaurants', restaurant_id);
                window.location = 'schedule'
            },
            getAreaName(area_id) {
                let item = _.find(this.areas, p => p.id == area_id);
                if (item) {
                    return item.name;
                }

                return '-';
            },
            restaurantEdited() {
                this.$store.dispatch('fetchRestaurants');
                this.$store.dispatch('fetchRestaurateurs');
            },
            onCangePerPage() {
                this.page = 1;
            },
            resetInvoicePin(restaurateur_id) {
                if (!confirm('Are you sure you want to reset the Invoice PIN?')) {
                    return
                }
                this.$store.dispatch('resetInvoicePin', restaurateur_id)
                    .then((response) => {
                        alert(response.message)
                    })
                    .catch(() => {})
            }
        },
    }
</script>

<style scoped>

</style>
